import { Button, CardMedia, IconButton, Input, MenuItem, Select, TextField } from "@mui/material";
import React, { ChangeEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import AIStyles from "../../Modals/AIstyles";
import SelectUpload from "../../Modals/select_upload";

const StoreBranding: React.FC = () => {
  const navigate = useNavigate();
  const storeMottoTemplates = [
    "Crafted with Care",
    "Made in the UAE",
    "Celebrate Local Creativity",
    // Admin can add more here
  ];

  const storeStoryTemplates = [
    "Born from a passion for craftsmanship, our store celebrates local artisans and the beauty of handmade traditions...",
    "Inspired by UAE heritage, our brand blends modern aesthetics with timeless cultural values...",
    "Built by creators for creators, our store is a home for unique products made with soul and purpose...",
  ];

  const [selectedMotto, setSelectedMotto] = useState("");
  const [customMotto, setCustomMotto] = useState("");

  const [selectedStoryTemplate, setSelectedStoryTemplate] = useState("");
  const [storeStory, setStoreStory] = useState("");

  const [showStoryEditor, setShowStoryEditor] = useState(false);
  const [openAIModal, setOpenAIModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  return (
    <>
      <div className="main_title">
        <h1>Store Branding</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Store Branding
        </p>
      </div>



      <div className="form full_width_img cards">

        <div className="gap_p">

          {/* ------------------- STORE BANNER ------------------- */}
          <div className="control_group wrap_viewDemo_steps">
            <label>Store Banner</label>
            <div className="upload_box">
              <label className="upload_action" onClick={() => setOpenModal(true)}>
                <p>
                  <img src="/static/images/upload_icon.svg" alt="icon" />
                  <strong>Upload Store Banner</strong>
                </p>
              </label>
            </div>
          </div>

          {/* =================== STORE MOTTO =================== */}
          <div className="control_group ai_rec_btn1">
            <label>Store Motto</label>

            {/* Templates */}

            <Select fullWidth value={"default"} className="select_abs">
              <MenuItem disabled value="default">
                Select Motto
              </MenuItem>
              {storeMottoTemplates.map((motto, index) => (
                <MenuItem value="All">  {motto}</MenuItem>
              ))}

            </Select>


            {/* Custom Input (editable after selecting template OR clicking AI) */}
            <TextField
              fullWidth
              placeholder="Enter custom motto"
              value={customMotto || selectedMotto}
              onChange={(e) => setCustomMotto(e.target.value)}

            />

            {/* AI Button */}
            <Button
              className="btn btn_primary sm"
              sx={{ mt: 2 }}
              onClick={() => {
                // Example AI logic
                const aiGenerated = "A modern celebration of UAE creativity.";
                setSelectedMotto(aiGenerated);
                setCustomMotto("");
              }}
            >
              <img
                style={{ filter: "brightness(0) invert(1)" }}
                src="/static/images/ai_icon.svg"
                alt=""
              />
              Generate with AI
            </Button>
          </div>

          {/* =================== STORE STORY =================== */}
          <div className="control_group ai_rec_btn">
            <label>Store Story / About Your Brand</label>


            <Select fullWidth value={"default"} className="select_abs">
              <MenuItem disabled value="default">
                Select Template
              </MenuItem>
              {storeStoryTemplates.map((template, index) => (
                <MenuItem value="All">{template}</MenuItem>
              ))}

            </Select>
            <TextField
              className="mt_20"
              id="Title"
              placeholder="Short Story"
              hiddenLabel
              fullWidth
              multiline
            />

            {/* AI Button */}
            <Button
              className="btn btn_primary sm"
              onClick={() => {
                const aiStory =
                  "Our journey began with a mission to empower local creators in the UAE. Every product in our store reflects passion, craftsmanship, and cultural pride...";
                setStoreStory(aiStory);
                setShowStoryEditor(true);
              }}
            >
              <img
                style={{ filter: "brightness(0) invert(1)" }}
                src="/static/images/ai_icon.svg"
                alt=""
              />
              Enhance with AI
            </Button>

            {/* Editable Text Field AFTER template/AI */}
            {showStoryEditor && (
              <TextField
                multiline
                fullWidth
                minRows={5}
                placeholder="Write your store story…"
                value={storeStory}
                onChange={(e) => setStoreStory(e.target.value)}
                sx={{ mt: 2 }}
              />
            )}
          </div>

        </div>

        <div className="btn_flx mt_20">
          <Button className="btn btn_primary">Edit</Button>
          <Button className="btn btn_primary">Save</Button>
        </div>
      </div>

      <AIStyles
        open={openAIModal}
        onClose={() => setOpenAIModal(false)}
        setOpen={setOpenAIModal}
      />
      <SelectUpload
        open={openModal}
        onClose={() => setOpenAIModal(false)}
        setOpen={setOpenModal}
      />

    </>
  );
};

export default StoreBranding;
